import { Injectable } from '@angular/core';
import { Adapter } from '@core/adapter';
import { Timezone } from '@app/shared/models/timezone.model';
import { TimezoneHelper } from '@core/services/helpers/timezone.helper';

@Injectable()
export class TimezoneAdapter implements Adapter<Timezone> {
    constructor(private timezoneHelper: TimezoneHelper) {}

    adapt(data: any): Timezone {
        const offsetCode = data.offsetCode || 'Etc/GMT';
        const offset = this.timezoneHelper.getOffsetString(
            this.timezoneHelper.getTimezoneData(offsetCode)
        );

        return {
            code: data.code || '',
            description: data.description || '',
            offset,
            offsetCode,
        } as Timezone;
    }
}
